import { isNil } from "lodash-es";
import IVendorModel from "../models/IVendorModel";

const getLocalVendorData = (): Promise<IVendorModel> => {
    return new Promise((resolve, reject) => {
        try {
            const vendor = localStorage.getItem("vendor");

            if (isNil(vendor)) {
                reject(new Error("Error finding vendor in local storage."));
            } else {
                const parsedVendor = JSON.parse(vendor) as IVendorModel;

                resolve(parsedVendor);
            }
        } catch (err) {
            reject(err);
        }
    });
};

const getLocalVendorDataFn = (): IVendorModel => {
    const vendor = localStorage.getItem("vendor");

    if (isNil(vendor)) {
        console.log("No vendor found in local storage, returning empty vendor model.");
        return {} as IVendorModel;
    } else {
        const parsedVendor = JSON.parse(vendor) as IVendorModel;
        return parsedVendor;
    }
};

const saveVendorData = (data: any) => {
    data.dataAge = Date.now();

    const vendorData = JSON.stringify(data);

    localStorage.setItem("vendor", vendorData);
};

const clearVendorData = () => {
    return new Promise((resolve, reject) => {
        try {
            localStorage.removeItem("vendor");

            resolve(true);
        } catch (err) {
            reject(err);
        }
    });
};

const VendorService = {
    clearVendorData,
    getLocalVendorData,
    getLocalVendorDataFn,
    saveVendorData,
};

export default VendorService;
